<template>
  <v-dialog v-model="showModal" max-width="700px">
    <v-card>
      <!-- Modal Header -->
      <v-card-title class="d-flex justify-space-between align-center">
        Add/Edit Comment
        <v-btn icon @click="hide">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Modal Body -->
      <v-card-text>
        <v-textarea
          label="Comment"
          v-model="meeting_comment"
          auto-grow
          rows="3"
          outlined
          data-cy="comment-modal-input"
        ></v-textarea>
      </v-card-text>

      <!-- Modal Footer -->
      <v-card-actions class="d-flex justify-space-between">
        <!-- Delete Button (Left-Aligned) -->
        <v-btn color="red" variant="outlined" @click="deleteComment" data-cy="comment-modal-delete-btn" :loading="loading">
          Delete
        </v-btn>
        
        <!-- Save Button (Right-Aligned) -->
        <v-btn color="primary" :loading="loading" @click="save" data-cy="comment-modal-save-btn">
          Save changes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAgendaStore } from "@/stores/parent/agenda";

const agendaStore = useAgendaStore();
const meeting_comment = ref("");
const pta_id = ref(null);
const loading = ref(false);
const showModal = ref(false);
function show(appointment = null) {
  if (appointment != null) {
    meeting_comment.value = appointment.comment;
    pta_id.value = appointment.pta_id;
    // console.log(meeting_comment.value);
    showModal.value = true;
    // modal.show();
  }
}
function hide() {
  showModal.value = false;
  // modal.hide();
}
defineProps({
  conference_id: Number
});

function save() {
  loading.value = true;
  const meeting_detail = {
    pta_id: pta_id.value,
    message: meeting_comment.value
  };
  // console.log(meeting_detail);
  agendaStore.saveDetails(meeting_detail).then((resp) => {
    agendaStore.getById(parseInt(resp.pta_id)).comment = resp.message;
    loading.value = false;
    hide();
  });
}

function deleteComment(){
  loading.value = true;
  const meeting_detail = {
    pta_id: pta_id.value,
  };
  // console.log(meeting_detail);
  agendaStore.deleteComment(meeting_detail).then((resp) => {
    agendaStore.getById(parseInt(pta_id.value)).comment = null;
    loading.value = false;
    hide();
  });
}

onMounted(() => {
  // modal = new Modal(commentModal.value);
});
defineExpose({
  show,
  hide
});
</script>
